import { render, staticRenderFns } from "./cpt-dataV-percentPond.vue?vue&type=template&id=453a5162&scoped=true"
import script from "./cpt-dataV-percentPond.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-percentPond.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453a5162",
  null
  
)

export default component.exports